import React from 'react';
import { StoreProvider } from './context/StoreContext';
import ErrorBoundary from './components/ErrorBoundary';
import AppLayout from './AppLayout';
import './index.css';

function App() {
  return (
    <ErrorBoundary>
      <StoreProvider>
        <AppLayout />
      </StoreProvider>
    </ErrorBoundary>
  );
}

export default App;